module.exports = __webpack_public_path__ + "e48c9929c7084a80b3b55d8f7a41581b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Notification.svg
// module id = 486
// module chunks = 5